import { useEffect } from 'react';

import { checkHash } from '../utils/utils';

export function useEnsureGuestCartHash(isAuthorized: boolean) {
  useEffect(() => {
    if (!isAuthorized) {
      const ensureHash = async () => {
        try {
          await checkHash();
        } catch {
          return undefined;
        }
      };

      ensureHash();
    }
  }, [isAuthorized]);
}
